import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
// import { CodeGuard } from "./guards/code.guard";
// import { HomeComponent } from "./pages/home/home.component";
import { NotFoundComponent } from "./pages/not-found/not-found.component";

const routes: Routes = [
  { path: "", redirectTo: "main", pathMatch: "full" },

  {
    path: "main",
    loadChildren: () =>
      import("./modules/main/main.module").then((m) => m.MainModule),
    // canLoad: [CodeGuard],
  },

  { path: "**", component: NotFoundComponent },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: "enabled",
      anchorScrolling: "enabled",
      scrollOffset: [-120, 120],
      useHash: false,
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
